import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { withSize } from '@bd/bdcore-utilities';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { css } from '@bd/bdui-styles/emotion';
import PageWrapper from '../../components/PageWrapper';
import { grid } from '../../styles';

import CTAComponent from '../../components/CTAComponent';
import PlanHeader from './PlanHeader';
import PlanFeatures from './PlanFeatures';
import PlanAbout from './PlanAbout';
import PlanTour from './PlanTour';
import FloorPlan from './ImagesList';
import PlanDetails from './PlanDetails';

const styles = css`
  .PlanAbout_wrapper {
    @media(min-width: 992px) {
      display: flex;
    }
    .PlanAbout_about {
      ${grid.makeCol(12)};
      padding: 0;
      @media(min-width: 992px) {
        ${grid.makeCol(8)};
      }
    }
    .PlanAbout_floorplan {
      ${grid.makeCol(12)};
      padding: 0;
      @media(min-width: 992px) {
        ${grid.makeCol(4)};
        display: flex;
        align-items: center;
      }
    }
  }
  .container {
    @media(max-width: 991px) {
      max-width: 100% !important;
      width: 100%;
      padding: 0;
    }
  }
  .container-fluid {
    padding: 0;
    @media(min-width: 992px) {
      padding: 0 15px;
      max-width: 1600px;
    }
  }
  .PlanDetails_section {
    @media(min-width: 992px) {
      display: flex;
    }

    .PlanDetails_wrapper {
      ${grid.makeCol(12)};
        padding: 0;
        background-color: #ffffff;
      @media(min-width: 992px) {
        ${grid.makeCol(6)};
        padding: 0;
      }
    }
  }
`;

function PlanDetail({ plan, size, community }) {
  const description = get(plan, 'custom_description', get(plan, 'description'));
  const seoTitle = `${get(plan, 'name')} Home Design${community ? ` in ${get(community, 'name')}` : ''}`;
  return (
    <PageWrapper singlePage className={styles}>
      <PageHelmet
        custom
        title={seoTitle}
      />
      <PlanHeader plan={plan} />
      <PlanDetails plan={plan} />
      {
        get(plan, 'elevationPhotos') && get(plan, 'elevationPhotos').length > 0 &&
        <FloorPlan list={get(plan, 'elevationPhotos')} increment={size.width > 991 ? 3 : 4} elevations title={'Additional Elevations'} />
      }
      {
        get(plan, 'floorplanPhotos') && get(plan, 'floorplanPhotos').length > 0 &&
        <FloorPlan list={get(plan, 'floorplanPhotos')} increment={2} title={'Floor Plans'} />
      }
      {
        get(plan, 'tourUrl') &&
        <PlanTour plan={plan} />
      }
      {
        description &&
        <PlanAbout description={description} />
      }
      {
        get(plan, 'features') &&
        <PlanFeatures plan={plan} />
      }
      <CTAComponent type="Plan" />
    </PageWrapper>
  );
}

PlanDetail.propTypes = {
  plan: PropTypes.object.isRequired,
  size: PropTypes.object.isRequired,
  community: PropTypes.object,
};

PlanDetail.defaultProps = {
  community: undefined,
};

export default withData(
  {
    plan: true,
    community: true,
  },
  {
    required: {
      plan: true,
    },
    ifMissing404: true,
  },
)(withSize()(PlanDetail));



// WEBPACK FOOTER //
// ./src/pages/PlanDetail/index.js